import {Pipe, PipeTransform} from '@angular/core';
import {regime_bens} from "../../../utils/constants.utils";

@Pipe({
  name: 'propertyRegimeLabel'
})
export class PropertyRegimeLabelPipe implements PipeTransform {

  transform(value: string): string {
    const found = regime_bens.find(item => item.optValue === value);
    return found ? found.optLabel : value;
  }

}
